export default __webpack_public_path__ + "static/media/terraform.5fcb4a67.png";